var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"owc-media-gallery-thumbnails"},[_c('div',{ref:"inner",staticClass:"owc-media-gallery-thumbnails__inner"},[_c('div',{ref:"grid",staticClass:"owc-media-gallery-thumbnails__grid"},_vm._l((_vm.thumbnails),function(item,index){return _c('div',{key:index,class:[
          'owc-media-gallery-thumbnails__grid-item',
          {
            'owc-media-gallery-thumbnails__grid-item--overflowing': _vm.indexOfOverflingItem === index,
          },
          {
            'owc-media-gallery-thumbnails__grid-item--active': _vm.value === index,
          },
        ],on:{"click":function($event){return _vm.selectItem(index)}}},[_c('GenericImage',{attrs:{"component-id":_vm.getThumbnailComponentId(item)}}),(_vm.isCarouselItemAVideo(item))?_c('div',{staticClass:"owc-media-gallery-thumbnails__video-overlay"},[_c('wb-icon',{staticClass:"owc-media-gallery-thumbnails__video-play-icon",attrs:{"name":"play"}})],1):_vm._e()],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }